// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'document-minus-solid';

export const Component = () => (
  <path d='M15.746 6.37 15.698.287l6.466 6.466.096.096h-6.034c-.335 0-.48-.144-.48-.479Zm.479 1.485h6.37v15.182c0 .431-.144.766-.432 1.054a1.408 1.408 0 0 1-1.054.43H3.485a1.41 1.41 0 0 1-1.054-.43A1.408 1.408 0 0 1 2 23.037V1.485c0-.431.144-.766.431-1.054A1.408 1.408 0 0 1 3.485 0H14.74v6.37c0 .43.144.766.431 1.053.288.288.623.432 1.054.432Zm1.485 7.327c0-.335-.191-.479-.526-.479h-9.77c-.336 0-.527.144-.527.479 0 .335.191.527.526.527h9.77c.336 0 .527-.192.527-.527Z' />
);

export const viewBox = '0 0 25 25';
